// HiBFF B2C Dashboard - Mock Data for All API Endpoints

export const mockUser = {
  user_id: 'usr_12345',
  name: 'Robert',
  email: 'robert@hibff.com',
  age: 45,
  subscription_tier: 'ava_companion',
  subscription_tier_name: 'HiBFF Pro',
  hearts_balance: 1250,
  current_streak: 12,
  next_streak_milestone: 15,
  streak_milestone_hearts: 50,
  onboarding_complete: true,
  theme: 'signature',
  has_memorial_avas: true,
  member_since: '2024-06-15T10:00:00Z',
  last_active: '2025-10-20T18:30:00Z'
};

export const mockAvAs = [
  {
    ava_id: 'ava_456',
    name: 'Sarah',
    personality_type: 'Encouraging',
    avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah&backgroundColor=b6e3f4',
    last_conversation: '2025-10-20T18:30:00Z',
    is_primary: true,
    conversation_count: 87,
    created_at: '2024-06-20T10:00:00Z'
  },
  {
    ava_id: 'ava_789',
    name: 'Mike from HiBFF',
    personality_type: 'Challenging',
    avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Mike&backgroundColor=c0aede',
    last_conversation: '2025-10-19T14:22:00Z',
    is_primary: false,
    conversation_count: 34,
    created_at: '2024-08-10T14:00:00Z'
  },
  {
    ava_id: 'ava_101',
    name: 'Emma',
    personality_type: 'Reflective',
    avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Emma&backgroundColor=ffd5dc',
    last_conversation: '2025-10-18T09:15:00Z',
    is_primary: false,
    conversation_count: 56,
    created_at: '2024-07-01T12:00:00Z'
  }
];

export const mockConversations = [
  {
    conversation_id: 'conv_001',
    ava_id: 'ava_456',
    ava_name: 'Sarah',
    ava_avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah&backgroundColor=b6e3f4',
    snippet: 'I really appreciate you sharing that with me. It takes courage to...',
    timestamp: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(), // 1 hour ago
    is_unread: false
  },
  {
    conversation_id: 'conv_002',
    ava_id: 'ava_789',
    ava_name: 'Mike from HiBFF',
    ava_avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Mike&backgroundColor=c0aede',
    snippet: "Let's work on those goals you set last week. How did it go?",
    timestamp: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(), // 5 hours ago
    is_unread: true
  },
  {
    conversation_id: 'conv_003',
    ava_id: 'ava_101',
    ava_name: 'Emma',
    ava_avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Emma&backgroundColor=ffd5dc',
    snippet: 'That sounds like a great plan! I think you should go for it.',
    timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(), // Yesterday
    is_unread: false
  },
  {
    conversation_id: 'conv_004',
    ava_id: 'ava_456',
    ava_name: 'Sarah',
    ava_avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah&backgroundColor=b6e3f4',
    snippet: "Remember, it's okay to take things one step at a time.",
    timestamp: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), // 2 days ago
    is_unread: false
  },
  {
    conversation_id: 'conv_005',
    ava_id: 'ava_789',
    ava_name: 'Mike from HiBFF',
    ava_avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Mike&backgroundColor=c0aede',
    snippet: 'Great progress on your fitness goals! Keep it up!',
    timestamp: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(), // 3 days ago
    is_unread: false
  }
];

// Generate dynamic mood data for the last 7 days
const generateMoodData = () => {
  const moods = [
    { score: 0.7, label: 'Good' },
    { score: 0.5, label: 'Okay' },
    { score: 0.8, label: 'Great' },
    { score: 0.6, label: 'Good' },
    { score: 0.75, label: 'Good' },
    { score: 0.9, label: 'Amazing' },
    { score: null, label: null } // Today - not logged yet
  ];

  return moods.map((mood, index) => {
    const date = new Date();
    date.setDate(date.getDate() - (6 - index));
    return {
      date: date.toISOString().split('T')[0],
      mood_score: mood.score,
      mood_label: mood.label
    };
  });
};

export const mockMoodData = generateMoodData();

export const mockBadges = [
  {
    badge_id: 'badge_001',
    name: 'Week Warrior',
    description: '7-day check-in streak',
    icon: '🔥',
    earned_date: '2025-10-18T10:00:00Z',
    rarity: 'common'
  },
  {
    badge_id: 'badge_002',
    name: 'Heart Collector',
    description: 'Earned 1000 hearts',
    icon: '💖',
    earned_date: '2025-10-12T14:30:00Z',
    rarity: 'rare'
  },
  {
    badge_id: 'badge_003',
    name: 'Conversation Master',
    description: '50 conversations completed',
    icon: '💬',
    earned_date: '2025-10-05T09:15:00Z',
    rarity: 'uncommon'
  }
];

export const mockActivityFeed = [
  {
    activity_id: 'act_001',
    type: 'conversation',
    icon: '💬',
    text: 'Had a conversation with Sarah',
    timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString() // 2 hours ago
  },
  {
    activity_id: 'act_002',
    type: 'badge',
    icon: '🏆',
    text: 'Earned "Week Warrior" badge',
    timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString() // Yesterday
  },
  {
    activity_id: 'act_003',
    type: 'checkin',
    icon: '✅',
    text: 'Completed daily check-in',
    timestamp: new Date(Date.now() - 26 * 60 * 60 * 1000).toISOString() // Yesterday
  },
  {
    activity_id: 'act_004',
    type: 'group',
    icon: '👥',
    text: 'Joined "Conversation Kick-Start" session',
    timestamp: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString() // 2 days ago
  },
  {
    activity_id: 'act_005',
    type: 'hearts',
    icon: '💖',
    text: 'Earned 25 hearts',
    timestamp: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString() // 3 days ago
  }
];

export const mockGroups = [
  {
    group_id: 'grp_001',
    name: 'Conversation Kick-Start',
    member_count: 24,
    last_activity: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    unread_messages: 3,
    next_session: new Date(Date.now() + 2 * 60 * 60 * 1000).toISOString(), // In 2 hours
    is_active: true
  },
  {
    group_id: 'grp_002',
    name: 'Confidence Building Circle',
    member_count: 18,
    last_activity: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
    unread_messages: 0,
    next_session: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(), // Tomorrow
    is_active: true
  },
  {
    group_id: 'grp_003',
    name: 'Wellness Warriors',
    member_count: 32,
    last_activity: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
    unread_messages: 7,
    next_session: new Date(Date.now() + 48 * 60 * 60 * 1000).toISOString(), // In 2 days
    is_active: true
  }
];

export const mockNotifications = [
  {
    notification_id: 'notif_001',
    type: 'group_session',
    icon: '📢',
    title: 'Group session starting soon',
    snippet: 'Conversation Kick-Start begins in 30 minutes',
    timestamp: new Date(Date.now() - 30 * 60 * 1000).toISOString(), // 30 mins ago
    is_unread: true,
    priority: 'high'
  },
  {
    notification_id: 'notif_002',
    type: 'streak_milestone',
    icon: '🔥',
    title: 'Streak milestone reached!',
    snippet: "You've reached a 12-day streak. Keep it going!",
    timestamp: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(), // 4 hours ago
    is_unread: true,
    priority: 'medium'
  },
  {
    notification_id: 'notif_003',
    type: 'new_message',
    icon: '💬',
    title: 'New message from Mike',
    snippet: 'Check out these tips for your morning routine',
    timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(), // Yesterday
    is_unread: false,
    priority: 'low'
  }
];

export const mockMemorialAvAs = [
  {
    memorial_id: 'mem_001',
    name: 'Dad',
    relationship: 'Father',
    avatar_url: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Dad&backgroundColor=d1d5db',
    passed_date: '2023-03-15',
    anniversary_days: 18,
    conversation_count: 45,
    last_conversation: '2025-10-15T16:00:00Z'
  }
];

export const mockSubscriptionTiers = [
  {
    tier_id: 'free',
    name: 'ENTRY',
    price: 0,
    billing_period: 'forever',
    features: [
      '3 saved practice partners (browse the full 800+ AvA library)',
      '15 free practice minutes',
      'Basic mood tracking',
      'Community access'
    ],
    hearts_per_month: 100
  },
  {
    tier_id: 'starter',
    name: 'CHALLENGER',
    price: 9,
    billing_period: 'month',
    features: [
      '8 saved practice partners (browse the full library)',
      'Unlimited text messages',
      'Voice chat included',
      'Mood tracking + insights'
    ],
    hearts_per_month: 200,
    popular: false
  },
  {
    tier_id: 'plus_monthly',
    name: 'THE ELITE',
    price: 33,
    billing_period: 'month',
    features: [
      '20 saved practice partners (browse the full library)',
      'Unlimited text messages',
      'Voice chat included',
      'Achievement NFTs',
      'Priority support'
    ],
    hearts_per_month: 1500,
    popular: true
  },
  {
    tier_id: 'plus_annual',
    name: 'MASTER',
    price: 290,
    billing_period: 'year',
    features: [
      '38 saved practice partners (browse the full library)',
      'Unlimited text messages',
      'Voice chat included',
      'Everything in The Elite',
      'Priority support',
      'Early access to new features'
    ],
    hearts_per_month: 5000,
    popular: false
  }
];

export const mockSubscription = {
  tier_id: 'plus_monthly',
  tier_name: 'THE ELITE',
  price: 33,
  billing_period: 'month',
  renewal_date: '2025-11-15',
  status: 'active',
  features: [
    '20 saved practice partners (browse the full library)',
    'Unlimited conversations',
    'Voice chat included',
    'Achievement NFTs'
  ],
  hearts_remaining: 1250,
  hearts_per_month: 1500
};

// Hardcoded Test Users for Authentication Demo
export const testUsers = [
  {
    user_id: 'usr_adult_001',
    name: 'John Smith',
    email: 'john@test.com',
    password: 'password123',
    dob: '1990-01-15',
    age: 35,
    subscription_tier: 'ava_companion',
    subscription_tier_name: 'HiBFF Pro',
    hearts_balance: 1250,
    current_streak: 8,
    verified: true,
    parentSetupComplete: null, // Not applicable for adults
    subscriptionDetails: {
      plan: 'HiBFF Pro',
      price: 48.88,
      subscribedDate: '2025-10-21',
      coolingOffEnds: '2026-01-19',
      daysRemaining: 90,
      totalPaid: 48.88,
      refundEligible: true,
      nextBillingDate: '2025-11-21',
      paymentMethod: '•••• 4242 (Visa)'
    },
    onboarding_complete: true,
    member_since: '2024-03-10T10:00:00Z',
    last_active: '2025-10-20T18:30:00Z'
  },
  {
    user_id: 'usr_teen_001',
    name: 'Emma Davis',
    email: 'emma@test.com',
    password: 'teen123',
    dob: '2010-05-20',
    age: 15,
    subscription_tier: 'free',
    subscription_tier_name: 'Free Tier',
    hearts_balance: 200,
    current_streak: 3,
    verified: true,
    parentEmail: 'parent@test.com',
    parentName: 'Sarah Davis',
    parentPhone: '(555) 123-4567',
    parentSetupComplete: false, // Waiting for parent setup
    onboarding_complete: false,
    member_since: '2025-10-15T12:00:00Z',
    last_active: '2025-10-15T12:30:00Z'
  },
  {
    user_id: 'usr_teen_002',
    name: 'Alex Chen',
    email: 'alex@test.com',
    password: 'test123',
    dob: '2009-08-12',
    age: 16,
    subscription_tier: 'ava_prime',
    subscription_tier_name: 'HiBFF Plus',
    hearts_balance: 450,
    current_streak: 12,
    verified: true,
    parentEmail: 'parent2@test.com',
    parentName: 'Linda Chen',
    parentPhone: '(555) 987-6543',
    parentSetupComplete: true, // Parent has completed setup
    parentSettings: {
      contentFilters: {
        supportAvas: true,
        coachAvas: true,
        friendAvas: true,
        memorialAvas: false,
        peerGroups: true,
        adultMentorSessions: false
      },
      timeLimits: {
        dailyLimit: '2hrs',
        quietHoursStart: '22:00',
        quietHoursEnd: '07:00',
        weekendSame: true,
        weekendLimit: '2hrs'
      },
      privacySettings: {
        viewMoodScores: true,
        viewTopicSummaries: true,
        viewTimeSpent: true,
        viewGroups: true,
        viewFullTranscripts: false
      },
      crisisAlerts: {
        smsCrisisButton: true,
        emailCrisisButton: true,
        moodPatternAlert: true
      }
    },
    onboarding_complete: true,
    member_since: '2025-09-01T10:00:00Z',
    last_active: '2025-10-20T16:45:00Z'
  },
  {
    user_id: 'usr_admin_001',
    name: 'Robert',
    email: 'robert@hibff.com',
    password: 'admin123',
    dob: '1980-03-10',
    age: 45,
    subscription_tier: 'ava_elite',
    subscription_tier_name: 'HiBFF Elite',
    hearts_balance: 5000,
    current_streak: 45,
    verified: true,
    parentSetupComplete: null,
    onboarding_complete: true,
    member_since: '2023-01-01T10:00:00Z',
    last_active: '2025-10-20T19:00:00Z'
  }
];
